import { isAuthenticated } from 'user-auth'
import { graphierQL } from 'utils'
import {
  SearchMapsQuery,
  SearchMapsQueryVariables
} from '~map-search/types/__generated/gql/graphql'

const searchMaps = async (variables: SearchMapsQueryVariables) => {
  const bool = await isAuthenticated()
  const data = await graphierQL<SearchMapsQuery, SearchMapsQueryVariables>({
    useToken: bool,
    query: searchMapsQuery,
    variables
  })

  return data
}

const searchMapsQuery = /* GraphQL */ `
  query SearchMaps(
    $coords: Coordinates
    $feedType: FEED_TYPES!
    $from: Int
    $query: String
    $size: Int
    $tagIds: [String!]
  ) {
    searchMaps(
      coords: $coords
      feedType: $feedType
      from: $from
      query: $query
      size: $size
      tagIds: $tagIds
    ) {
      total
      items {
        id
        createdAt
        updatedAt
        dataId
        name
        likes
        views
        workspace {
          id
          name
          logo
        }
        mapTagCollection {
          total
          items {
            tag {
              id
              name
              type
            }
          }
        }
      }
    }
  }
`

export { searchMaps, searchMapsQuery }
